import type { RouteObject } from "react-router-dom";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";
import TopicsPage from "../pages/topics/page";
import TopicDetailPage from "../pages/topic-detail/page";
import DiscussionPage from "../pages/discussion/page";
import AboutPage from "../pages/about/page";
import FaqPage from "../pages/faq/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "topics",
        element: <TopicsPage />,
      },
      {
        path: "topic/:id",
        element: <TopicDetailPage />,
      },
      {
        path: "discussion",
        element: <DiscussionPage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "faq",
        element: <FaqPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;